<template>
  <div class="row bg-white shadow py-5 px-3 mb-4">
    <div class="col-11">
      <div class="row">
        <div class="col-2 text-center">
          <b>#</b>
        </div>
        <div class="col-2">
          <b>Estado</b>
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col-4">
              <b>Aduana Loteadora</b>
            </div>
            <div class="col-2">
              <b>Requiere VB</b>
            </div>
            <div class="col-2">
              <b>Ex Lote</b>
            </div>
            <div class="col-3">
              <b>Calidad jurídica</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1 text-center">
      <b>...</b>
    </div>
  </div>
</template>

<script>

export default {};

</script>
